const TabPanel = ({ children }) => {
  return children;
};

export default TabPanel;
